var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowSide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52284 12.4623C7.81981 12.751 7.82647 13.2259 7.53771 13.5228C7.24896 13.8198 6.77413 13.8265 6.47716 13.5377L0.477158 7.70365C0.180107 7.41482 0.173537 6.93983 0.462487 6.64289L6.46249 0.476952C6.75136 0.180092 7.22619 0.173615 7.52305 0.462487C7.81991 0.751358 7.82639 1.22619 7.53751 1.52305L2.06076 7.15127L7.52284 12.4623Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_795",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 8,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52284 12.4623C7.81981 12.751 7.82647 13.2259 7.53771 13.5228C7.24896 13.8198 6.77413 13.8265 6.47716 13.5377L0.477158 7.70365C0.180107 7.41482 0.173537 6.93983 0.462487 6.64289L6.46249 0.476952C6.75136 0.180092 7.22619 0.173615 7.52305 0.462487C7.81991 0.751358 7.82639 1.22619 7.53751 1.52305L2.06076 7.15127L7.52284 12.4623Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_795)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSide);
export default __webpack_public_path__ + "static/media/arrowSide.a1dabe98a54738aff1e5f15da39e4a48.svg";
export { ForwardRef as ReactComponent };